import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import {
  compose,
  setPropTypes,
  withState,
  lifecycle,
  withHandlers
} from 'recompose';
import { withRouter } from 'react-router';
import { withStyles } from '@material-ui/core/styles';
import Paper from '@material-ui/core/Paper';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableRow from '@material-ui/core/TableRow';
import Typography from '@material-ui/core/Typography';
import StripeButton from '../../components/atoms/StripeButton';
import BackButton from '../../components/atoms/BackButton';
import MenuDrawerGroup from '../../components/MenuDrawerGroup';
import { isAuthenticated } from '../../auth/Auth';

const styles = theme => ({
  root: {
    // backgroundColor: '#e0e0e0',
    // flexGrow: 1,
    // width: '100%'
    display: 'flex'
  },
  content: {
    flexGrow: 1,
    padding: theme.spacing(3),
    width: 'calc(100% - 240px)'
  },
  title: {
    color: '#000',
    fontSize: 24,
    fontWeight: 'bold',
    marginBottom: 15
  },
  pageTitileDiv: {
    textAlign: 'left'
  },
  mainPaper: {
    position: 'relative',
    marginTop: 10,
    padding: 10
  },
  detailTable: {
    width: 'auto'
  },
  tableCellItem: {
    border: '2px solid #ffffff'
  },
  tableCellData: {
    border: '2px solid #ffffff'
  },
  boldText: {
    fontWeight: 'bold',
    fontSize: '16px',
    color: 'rgba(0, 0, 0, 0.87)'
  },
  boldRed: {
    fontWeight: 'bold',
    color: '#ff0000'
  }
});

const propTypes = {
  classes: PropTypes.object.isRequired
};

const enhance = compose(
  connect(state => ({
    account: state.accounts.account,
    name: state.loginInfo.name,
    groupDetails: state.groups.detail
  })),
  setPropTypes(propTypes),
  withState('openDrawer', 'updateOpenDrawer', false),
  withHandlers({
    handleRedirect: props => path => {
      props.history.push(path);
    }
  }),
  lifecycle({
    componentDidMount() {
      isAuthenticated(this.props);
    }
  })
);

const Main = enhance(({ classes, account, handleRedirect, groupDetails }) => {
  const isShop = typeof account !== 'undefined' && account.role === 'SHOP';
  const isReleased =
    account && account.accountStatus && account.accountStatus.status === true;
  const stripeAccountDone =
    groupDetails &&
    groupDetails.groupAccountStatus &&
    groupDetails.groupAccountStatus.stripeAccount === true;
  const backAction = () => handleRedirect('/release_step');
  return (
    <div className={classes.root}>
      <MenuDrawerGroup title="Stripeに連結する" />
      <main className={classes.content}>
        <Typography variant="h6" noWrap className={classes.title}>
          Stripeに連結する
        </Typography>
        <div className={classes.pageTitileDiv}>
          <Typography color="textSecondary">
            本機能は、決済基盤の変更9/8をもちまして終了となりました。
          </Typography>
        </div>
        <Paper className={classes.mainPaper} elevation={1}>
          <Table className={classes.detailTable}>
            <TableBody>
              {!stripeAccountDone ? (
                <React.Fragment>
                  <TableRow>
                    <TableCell className={classes.tableCellData}>
                      <div className={classes.boldText}>{account.email}</div>
                      <div className={classes.boldRed}>
                        下記、Stripeで登録するメールアドレスは、こちらに表示されているごちめし登録のメールアドレスと同一のメールアドレスで、登録してください。
                        <br />
                        {`（ `}
                        ごちめしとStripeを紐付けるには2つのメールアドレスが一致している必要があります。
                        {` ）`}
                      </div>
                    </TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell className={classes.tableCellData}>
                      <StripeButton disabled />
                    </TableCell>
                  </TableRow>
                </React.Fragment>
              ) : (
                <TableRow>
                  <TableCell className={classes.tableCellData}>
                    <div className={classes.boldText}>
                      既にStripeに紐づけています。
                    </div>
                  </TableCell>
                </TableRow>
              )}
              {/* <TableRow>
                <TableCell className={classes.tableCellData}>
                  <div>
                    <Link
                      href="https://dashboard.stripe.com/login"
                      target="_blank"
                      className={classes.link}
                    >
                      Stripeログイン画面はこちら
                    </Link>
                  </div>
                </TableCell>
              </TableRow> */}
            </TableBody>
          </Table>
          {isShop && !isReleased && (
            <div>
              <BackButton onClickAction={backAction} />
            </div>
          )}
        </Paper>
      </main>
    </div>
  );
});

export default withRouter(withStyles(styles)(Main));
